import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Strips from '../../../styles/staticAssets/images/Strips.svg';
import { PRIVACY_CONSTANTS } from '../Constants/PrivacyPageConstants';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

const PrivacyHeader = props => {
  const { headerData = {}, userParams } = props;
  // const { title = '', effectiveDate = '' } = headerData && headerData; Have Sonar Issue
  const { title = '', effectiveDate = '' } = headerData;
  const { EFFECTIVE_DATE } = PRIVACY_CONSTANTS;
  const CustomStylDiv = useStyleScripts(STYLE_SCRIPT_CONST?.OUR_ADS_STYLES);

  return (
    CustomStylDiv && (
      <CustomStylDiv className={`privacy-header-container${userParams?.localized ? ' localized' : ''}`}>
        <img src={Strips} className='privacy-icon' alt='' />
        <h1 className='privacy-header'>{title}</h1>
        <div className='privacy-eff-date'>
          {translateWithI18Next(EFFECTIVE_DATE)} {effectiveDate}
        </div>
      </CustomStylDiv>
    )
  );
};

export default PrivacyHeader;
